// extracted by mini-css-extract-plugin
module.exports = {"searchCard":"Card_searchCard__1XOAw","highlights":"Card_highlights__2pVzP"};